/**
 * General formatting utilities for display purposes
 */
/**
 * Format a relationship type enum value to title case for display
 * e.g., "TENANT" → "Tenant", "OWNER" → "Owner"
 *
 * @param relationshipType - The relationship type enum value (e.g., "TENANT", "OWNER")
 * @returns The formatted display label (e.g., "Tenant", "Owner")
 */
export function formatRelationshipTypeLabel(relationshipType) {
    if (!relationshipType) {
        return '';
    }
    return (relationshipType.charAt(0).toUpperCase() +
        relationshipType.slice(1).toLowerCase());
}
/**
 * Format a camelCase variable name into a readable label.
 * Handles acronyms: "listingURL" → "Listing URL", "firstName" → "First name"
 */
export function formatVariableLabel(name) {
    const spaced = name.replace(/([a-z])([A-Z])/g, '$1 $2');
    return spaced
        .split(' ')
        .map((word, i) => {
        if (word === word.toUpperCase() && word.length > 1)
            return word;
        return i === 0
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : word.toLowerCase();
    })
        .join(' ');
}
//# sourceMappingURL=formatting-utils.js.map